<template>
  <div class="panel-wrap">
    <div class="field">
      <label>复诊情况</label>
      <div class="readonly-input">{{ form.summary.stage || '--' }}</div>
    </div>
    <div class="field">
      <label>当前状态</label>
      <div class="readonly-input">{{ form.summary.status || '--' }}</div>
    </div>
    <div class="field">
      <label style="display: flex; align-items: center">
        <span>关键风险</span>
        <span class="required-mark">*</span>
      </label>
      <a-input v-model:value="riskValue" placeholder="请输入" maxLength="20" />
    </div>
    <div class="field">
      <label>待办事项</label>
      <div class="readonly-input">{{ form.summary.todo || '--' }}</div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue'
import { createFieldModel } from '../../hooks/useFieldModel'

const props = defineProps({
  form: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update-field'])

const riskValue = createFieldModel(() => props.form, 'summary', 'risk', emit)
</script>

<style lang="scss" scoped>
.panel-wrap {
  padding-top: 8px;
}

.field {
  min-width: 0;
  box-sizing: border-box;
  margin-bottom: 16px;

  label {
    display: block;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
  }

  .required-mark {
    color: #f84f4f;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    margin-left: 3px;
    display: block;
    height: 16px;
  }

  .readonly-input {
    min-height: 36px;
    padding: 7px 12px;
    border: 1px solid #ececec;
    border-radius: 4px;
    background: #fafafa;
    color: #a3a3a3;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    user-select: none;
  }

  :deep(.ant-input) {
    height: 36px;
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    box-shadow: none;
    padding: 5px 12px;
    color: #333;
    font-size: 14px;
    line-height: 20px;
    background: #fff;
    box-sizing: border-box;
  }

  :deep(.ant-input::placeholder) {
    color: #b8b8b8;
  }
}
</style>
